// _bnovo.ts
import styles from './bnovo.module.scss'
export const BNOVO_HORIZONTAL_CONTAINER_ID = styles.bnWidgedHorizontal;
export const BNOVO_VERTICAL_CONTAINER_ID = styles.bnWidgedVertical;
export const BNOVO_VERTICAL_CONTAINER_ID2 = styles.bnWidgedVertical2;

const SCRIPT_ID = 'bnovo-widget-script';

const BASE_WIDGET_CONFIG = {
  uid: "09f2faca-1767-47e1-8071-e7fb9741eee6",
  lang: "ru",
  width: "100%",
  width_mobile: "300",
  background: "white",
  background_mobile: "white",
  bg_alpha: "0",
  bg_alpha_mobile: "0",
  border_color_mobile: "#fff",
  padding: "0",
  padding_mobile: "24",
  border_radius: "15",
  button_font_size: "14",
  button_height: "42",
  font_type: "inter",
  without_title: "on",
  title_color: "#242742",
  title_color_mobile: "#242742",
  title_size: "22",
  title_size_mobile: "22",
  inp_color: "#242742",
  inp_bordhover: "#BBBBBB",
  inp_bordcolor: "#DDDDDD",
  inp_alpha: "100",
  btn_background: "#AA895C",
  btn_background_over: "#9d7d51",
  btn_textcolor: "#FFFFFF",
  btn_textover: "#FFFFFF",
  btn_bordcolor: "#AA895C",
  btn_bordhover: "#9d7d51",
  min_age: "0",
  max_age: "17",
  adults_default: "1",
  cancel_color: "#AA895C",
  switch_mobiles_width: "800",
};

// Перехватываем ошибки iframe
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (
      event.message?.includes("reading 'postMessage'") ||
      event.filename?.includes('bnovo.js')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }, true);
}

let isInitialized = false;

export const initBnovoWidgets = () => {
  if (isInitialized) return;

  const safeInit = (retries = 10) => {
    // @ts-ignore
    const bnovo = window.Bnovo_Widget;

    if (bnovo && typeof bnovo.init === 'function') {
      try {
        bnovo.init(() => {
          // @ts-ignore
          const widget = window.Bnovo_Widget;
          if (!widget || typeof widget.open !== 'function') return;

          // Инициализация горизонтального виджета
          if (document.getElementById(BNOVO_HORIZONTAL_CONTAINER_ID)) {
            widget.open(BNOVO_HORIZONTAL_CONTAINER_ID, {
              ...BASE_WIDGET_CONFIG,
              type: 'horizontal',
            });
          }

          // Инициализация вертикального виджета
          if (document.getElementById(BNOVO_VERTICAL_CONTAINER_ID)) {
            widget.open(BNOVO_VERTICAL_CONTAINER_ID, {
              ...BASE_WIDGET_CONFIG,
              type: 'vertical',
            });
          }

          if (document.getElementById(BNOVO_VERTICAL_CONTAINER_ID2)) {
            widget.open(BNOVO_VERTICAL_CONTAINER_ID2, {
              ...BASE_WIDGET_CONFIG,
              type: 'vertical',
            });
          }

          isInitialized = true;
        });
      } catch (e) {
        console.warn("Bnovo widget init error:", e);
      }
    } else if (retries > 0) {
      setTimeout(() => safeInit(retries - 1), 50);
    }
  };

  // @ts-ignore
  if (window.Bnovo_Widget) {
    safeInit();
    return;
  }

  let script = document.getElementById(SCRIPT_ID) as HTMLScriptElement;

  if (!script) {
    script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = "https://widget.reservationsteps.ru/js/bnovo.js";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
  }

  script.onload = () => {
    safeInit();
  };

  script.onerror = () => {
    console.warn("Failed to load Bnovo widget script");
  };
};